module.exports = __webpack_public_path__ + "img/Nakamoto.5868798d.png";